/**
 * AdminBar — dauerhaft sichtbare, farbige Leiste im „Bearbeiten für"-Modus.
 *
 * Zeigt „Du bearbeitest für <Name>" und einen „Beenden"-Button, der die
 * Bearbeitung beendet (zurück zur eigenen Sicht). Secondary-Farbe, damit der
 * Modus klar erkennbar ist (nicht nur über Text).
 */

import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import { useI18n } from "../../i18n/I18nProvider";

export default function AdminBar({
  name,
  onEnd,
}: {
  name: string;
  onEnd: () => void;
}) {
  const { t } = useI18n();
  return (
    <Box
      sx={{
        bgcolor: "secondary.main",
        color: "secondary.contrastText",
        px: 2,
        py: 1,
        display: "flex",
        alignItems: "center",
        gap: 1,
      }}
    >
      <Typography flex={1} fontWeight={700} fontSize={14}>
        {t("weeklyPlan.admin.editingFor", { name })}
      </Typography>
      <Button
        size="small"
        color="inherit"
        variant="outlined"
        onClick={onEnd}
        sx={{ minHeight: 44 }}
      >
        {t("weeklyPlan.admin.end")}
      </Button>
    </Box>
  );
}
